/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Teams_IconInputs */

const en_tables_teams_icon = /** @type {(inputs: Tables_Teams_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon`)
};

const de_tables_teams_icon = /** @type {(inputs: Tables_Teams_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon`)
};

/**
* | output |
* | --- |
* | "Icon" |
*
* @param {Tables_Teams_IconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_teams_icon = /** @type {((inputs?: Tables_Teams_IconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Teams_IconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_teams_icon(inputs)
	return de_tables_teams_icon(inputs)
});